import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";
import dayjs from "dayjs";
import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import TopBarMenu from "../../components/common/TopBarMenu";
import { FaVideo, FaUserMd, FaRegCopy, FaPhone } from "react-icons/fa";
import {
  getMeeting,
  upsertMeeting,
  inviteMeeting,
} from "../../utils/api/Meeting/Dashboard/Meeting";

const MeetingPage = ({ store, match }) => {
  const [meeting, setMeeting] = useState(undefined);
  const [
    gorusmeOncesiBilgilendirmeDisplay,
    setGorusmeOncesiBilgilendirmeDisplay,
  ] = useState(false);
  const [acceptedAllBilgilendirme, setAcceptedAllBilgilendirme] =
    useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [meetingStatusDialog, setMeetingStatusDialog] = useState(false);
  const [showInvite, setShowInvite] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchMeeting = async () => {
      if (!store.isLogin) {
        store.setLoadingBarStatus(true);
        store.setMessage("Lütfen kullanıcı girişi yapınız", true, "error");
        navigate("/panel/kullanici-girisi");
      } else {
        store.setLoadingBarStatus(true);
        if (store.trainer !== undefined) {
          let meetingReq = await getMeeting(store.baseUrl, store.token, id);

          if (meetingReq !== null && meetingReq !== undefined) {
            if (meetingReq.status === 200) {
              if (meetingReq.data.data.videoUrl) {
                setMeeting(meetingReq.data.data);
              } else {
                store.setMessage("Görüşme bulunamadı", true, "error");
              }
              // } else {
              //   store.setUserLogout();
              //   navigate("/panel/kullanici-girisi");
            }
          }
          store.setLoadingBarStatus(true);
        }
      }
    };

    fetchMeeting();
  }, [id]);

  const startVideoProcess = async () => {
    if (meeting.endDate) {
      return store.setMessage("Görüşme sona erdi", true, "error");
    }
    setGorusmeOncesiBilgilendirmeDisplay(true);
  };

  const onAcceptedGorusmeOncesiBilgilendirme = async () => {
    setAcceptedAllBilgilendirme(true);
    setGorusmeOncesiBilgilendirmeDisplay(false);

    store.setLoadingBarStatus(false);

    const utcDiff = dayjs().utcOffset();
    const currentDate = dayjs().add(utcDiff, "minute");
    const newMeeting = {
      ...meeting,
      isStarted: true,
      meetingDate: currentDate,
    };
    const videoLink = meeting.videoUrl;

    if (meeting.isStarted) {
      setVideoUrl(videoLink);
    } else {
      const upsertMeetingReq = await upsertMeeting(
        store.baseUrl,
        store.token,
        store.trainer.id,
        newMeeting
      );
      if (upsertMeetingReq !== undefined && upsertMeetingReq !== null) {
        if (upsertMeetingReq.status === 200) {
          setVideoUrl(videoLink);
          setMeeting(upsertMeetingReq.data.data);
        } else {
          store.setMessage(
            "Görüşme işlemi sırasında hata oluştu",
            true,
            "error"
          );
        }
      }
    }

    store.setLoadingBarStatus(true);
  };

  const endMeeting = async (setStatus) => {
    store.setLoadingBarStatus(false);

    const utcDiff = dayjs().utcOffset();
    const currentDate = dayjs().add(utcDiff, "minute");
    let newMeeting;
    if (setStatus) {
      const status =
        Number(document.querySelector("#meeting-status+input")?.value) ?? 0;
      newMeeting = { ...meeting, endDate: currentDate, status };
    } else {
      newMeeting = { ...meeting, endDate: currentDate };
    }

    const upsertMeetingReq = await upsertMeeting(
      store.baseUrl,
      store.token,
      store.trainer.id,
      newMeeting
    );

    if (upsertMeetingReq !== undefined && upsertMeetingReq !== null) {
      if (upsertMeetingReq.status === 200) {
        navigate("/panel");
      } else {
        store.setMessage("Görüşme işlemi sırasında hata oluştu", true, "error");
      }
    }
    store.setLoadingBarStatus(true);
  };

  const endMeetingHandler = () => {
    window.removeEventListener("beforeunload", (e) => {
      e.preventDefault();
    });
    setMeetingStatusDialog(true);
  };

  const copyInviteLink = (link) => {
    navigator.clipboard.writeText(link);
    store.setMessage("Davet adresi kopyalandı", true, "success");
    handleInviteDialog();
  };

  const handleInviteDialog = () => {
    setShowInvite(!showInvite);
  };

  const inviteNumber = async () => {
    const phone = document.getElementById("mobilePhone").value;
    if (
      Number(phone)?.toString().startsWith("5") &&
      Number(phone).toString().length === 10
    ) {
      const sendInviteReq = await inviteMeeting(
        store.baseUrl,
        store.token,
        store.trainer.id,
        { mobilePhone: phone, meetingId: id }
      );

      if (sendInviteReq !== undefined && sendInviteReq !== null) {
        if (sendInviteReq.status === 200) {
          store.setMessage("Davet gönderildi", true, "success");
          document.getElementById("mobilePhone").value = "";
        } else {
          store.setMessage("Davet sırasında sorun oluştu", true, "error");
        }
      } else store.setMessage("Davet sırasında sorun oluştu", true, "error");
    } else {
      store.setMessage("Geçersiz numara", true, "error");
    }
  };

  const inviteLink =
    window.location.origin +
    "/meet/" +
    meeting?.videoUrl?.split("/")[3]?.split("?")[0];

  return (
    <div className="container mps-container">
      <TopBarMenu meeting hideLeave />
      <Container maxWidth={false} style={{ paddingTop: "80px" }}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} xl={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Card
                  style={{
                    height: "100%",
                    borderRadius: "10px",
                    marginTop: "0px",
                  }}
                >
                  {meeting && (
                    <CardContent style={{ height: "auto", padding: "10px" }}>
                      <Grid
                        container
                        spacing={1}
                        alignItems={"center"}
                        justifyContent={"flex-end"}
                      >
                        <Grid
                          item
                          style={{
                            marginInlineEnd: "auto",
                          }}
                        >
                          <Typography
                            variant="body2"
                            style={{
                              fontSize: "20px",
                            }}
                          >
                            <b>{meeting?.meetingName}</b>
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body2">
                            <b>Oturum bilgileri: </b>
                            {`${dayjs(meeting?.meetingDate).format(
                              "DD.MM.YYYY hh:mm"
                            )} - ${meeting?.duration} dk`}
                          </Typography>
                        </Grid>
                        {videoUrl && (
                          <Grid item>
                            <Button
                              variant="contained"
                              color="error"
                              onClick={endMeetingHandler}
                            >
                              Görüşmeyi Bitir
                            </Button>
                          </Grid>
                        )}
                        <Grid item>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() => navigate(-1)}
                          >
                            Geri Dön
                          </Button>
                        </Grid>
                      </Grid>
                    </CardContent>
                  )}
                </Card>
              </Grid>
              <Grid item xs={12} style={{ paddingTop: "0px" }}>
                <Card
                  style={{
                    height: "calc(100vh - 260px)",
                    borderRadius: "10px",
                    marginTop: "20px",
                  }}
                >
                  <CardContent style={{ padding: "0", height: "100%" }}>
                    {videoUrl !== "" ? (
                      <iframe
                        allow="camera;microphone;display-capture;fullscreen"
                        id="meeting-iframe"
                        src={videoUrl}
                        title="Görüşme Ekranı"
                        style={{
                          height: "100%",
                          width: "100%",
                          border: "0",
                        }}
                      />
                    ) : (
                      <div className="session-start-screen">
                        <div className="trainerr-image">
                          <FaUserMd
                            style={{
                              fontSize: "200px",
                              color: "#ff5969",
                              borderRadius: "150px",
                              border: "7px solid #ff5969",
                              marginBottom: "15px",
                            }}
                          />
                        </div>

                        {meeting &&
                          (meeting.endDate ? (
                            <Button
                              variant="contained"
                              color="error"
                              onClick={() => navigate("/panel")}
                            >
                              Görüşme Sona Erdi
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={startVideoProcess}
                              disabled={
                                meeting?.appointmentType === 2 ? true : false
                              }
                            >
                              <FaVideo
                                style={{
                                  fontSize: "24px",
                                  marginRight: "15px",
                                }}
                              />{" "}
                              Görüşmeyi Başlat
                            </Button>
                          ))}
                      </div>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Dialog open={gorusmeOncesiBilgilendirmeDisplay}>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Bilgilendirme
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Değerli kullanıcımız, hizmetin yerine getirilebilmesi için{" "}
            <b>kamera ve mikrofon erişim izni </b>gerekmektedir. Yapacağınız
            görüşmeyi karşı tarafa bildirerek istediğiniz anda
            sonlandırabilirsiniz.
          </Typography>
          <Typography>
            Karşı taraf ile yapacağınız görüşmede{" "}
            <b>gerektiğinde ses ve görüntü kaydı yapılabilmektedir.</b>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={onAcceptedGorusmeOncesiBilgilendirme}
          >
            Devam Et
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={showInvite} onClose={handleInviteDialog}>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Davet
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleInviteDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon onClick={handleInviteDialog} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography style={{ textAlign: "center" }}>
                <b>Davet Adresi: </b>
                {inviteLink}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                style={{ width: "100%" }}
                onClick={() => copyInviteLink(inviteLink)}
              >
                Davet Adresini Kopyala
                <FaRegCopy style={{ marginInlineStart: "5px" }} />
              </Button>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="mobilePhone"
                name="mobilePhone"
                variant="outlined"
                label="Telefon Numarası"
                style={{ width: "100%", marginTop: "15px" }}
              ></TextField>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                style={{ width: "100%", marginTop: "15px" }}
                onClick={inviteNumber}
              >
                Davet Gönder
                <FaPhone style={{ marginInlineStart: "5px" }} />
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog open={meetingStatusDialog} onClose={() => endMeeting(false)}>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Oturum Sonlandırılacak
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => endMeeting(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon onClick={() => endMeeting(false)} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ minWidth: "400px" }}>
          <Grid container>
            <Grid item xs={12}>
              <FormControl
                fullWidth
                style={{ width: "100%", marginTop: "15px" }}
              >
                <InputLabel id="meeting-status-label">
                  Görüşme Durumu
                </InputLabel>
                <Select
                  defaultValue={0}
                  labelId="meeting-status-label"
                  id="meeting-status"
                  label="Görüşme Durumu"
                >
                  <MenuItem value={1}>Tamamlandı</MenuItem>
                  <MenuItem value={2}>Tamamlanmadı</MenuItem>
                  <MenuItem value={0}>Bekleniyor</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            onClick={() => endMeeting(true)}
          >
            Görüşmeden Ayrıl
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default inject("store")(observer(MeetingPage));
